import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { Button } from "@/shared/components/ui/button";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { Key } from "react";
import t from "@/lang/lang";

export function OrderBySelect<T>({
  orderBy,
  onOrderByChange,
  fields,
}: {
  orderBy: OrdrBy<T>[] | undefined;
  onOrderByChange: (orderBy: OrdrBy<T>[]) => void;
  fields: { label: string; value: T }[];
}) {
  // This allows us to accept undefined orderBy,
  // which is common in list requests. This makes
  // it nicer to call the component.
  const orderByVal = orderBy ?? [];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <ArrowUpDown className="size-4" />
          <span>{t("Sortieren")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuLabel>Sortieren nach</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {fields.map((field) => (
          <div
            className="flex items-center justify-between"
            key={field.value as Key}
          >
            <DropdownMenuCheckboxItem
              className="flex-grow"
              checked={orderByVal.some((o) => o.field === field.value)}
              onCheckedChange={(checked) => {
                if (checked) {
                  onOrderByChange([...orderByVal, { field: field.value }]);
                } else {
                  onOrderByChange(
                    orderByVal.filter((o) => o.field !== field.value),
                  );
                }
              }}
            >
              {field.label}
            </DropdownMenuCheckboxItem>
            <DescendingToggle
              value={orderByVal.some((o) => o.field === field.value && o.dsc)}
              onChange={(dsc) => {
                onOrderByChange(
                  orderByVal.map((o) => {
                    if (o.field !== field.value) {
                      return o;
                    }
                    return { ...o, dsc };
                  }),
                );
              }}
            />
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function DescendingToggle({
  value,
  onChange,
}: {
  value: boolean | undefined;
  onChange: (dsc: boolean) => void;
}) {
  return (
    <Button variant="ghost" size="sm" onClick={() => onChange(!value)}>
      {value ? <ArrowDown size="4" /> : <ArrowUp size="4" />}
    </Button>
  );
}
